export default __webpack_public_path__ + "static/media/ic_marker_destiny.49390dbc.svg";